<zag-drawer
  class="audit-log-panel__drawer"
  [open]="open()"
  [plain]="true"
  [mode]="drawerMode()"
  position="right"
  width="380px"
  mobileWidth="100%"
  [showBackdrop]="true"
  (openChange)="openChange.emit($event)"
>
  <div class="audit-log-panel">
    <!-- Header -->
    <div class="audit-log-panel__header">
      <h2 class="audit-log-panel__title">
        <span zagIcon="history" class="audit-log-panel__title-icon"></span>
        {{ 'audit.panel.title' | translate }}
      </h2>
      <button
        type="button"
        class="audit-log-panel__close-btn"
        [attr.aria-label]="'audit.panel.close' | translate"
        [attr.title]="'audit.panel.close' | translate"
        (click)="close()"
      >
        <span zagIcon="close"></span>
      </button>
    </div>

    <!-- Content -->
    <div class="audit-log-panel__content">
      @if (isLoading()) {
        <div class="audit-log-panel__loading">
          <span zagIcon="sync" class="spinning"></span>
          <p>{{ 'common.loading' | translate }}</p>
        </div>
      } @else if (hasError()) {
        <div class="audit-log-panel__error">
          <span zagIcon="error-outline"></span>
          <p>{{ 'common.error' | translate }}</p>
        </div>
      } @else {
        @if (changes().length === 0) {
          <div class="audit-log-panel__empty">
            {{ 'audit.panel.empty' | translate }}
          </div>
        } @else {
          @for (change of changes(); track change.id; let isLast = $last) {
            @let diff = getDiffEntries(change.id);
            <article class="audit-log-panel__entry" [class.audit-log-panel__entry--expanded]="isExpanded(change.id)">
              <button
                type="button"
                class="audit-log-panel__entry-header"
                [attr.aria-expanded]="isExpanded(change.id)"
                [attr.aria-controls]="'audit-log-change-' + change.id"
                (click)="toggleExpanded(change.id)"
              >
                <div class="audit-log-panel__entry-indicator">
                  <div
                    class="audit-log-panel__entry-dot"
                    [class.audit-log-panel__entry-dot--insert]="change.operation === 'INSERT'"
                    [class.audit-log-panel__entry-dot--update]="change.operation === 'UPDATE'"
                    [class.audit-log-panel__entry-dot--delete]="change.operation === 'DELETE'"
                  >
                    <span [zagIcon]="operationIcon(change)" class="audit-log-panel__entry-op-icon"></span>
                  </div>

                  @if (!isLast) {
                    <div
                      class="audit-log-panel__entry-line"
                      [class.audit-log-panel__entry-line--insert]="change.operation === 'INSERT'"
                      [class.audit-log-panel__entry-line--update]="change.operation === 'UPDATE'"
                      [class.audit-log-panel__entry-line--delete]="change.operation === 'DELETE'"
                    ></div>
                  }
                </div>

                <div class="audit-log-panel__entry-content">
                  <div class="audit-log-panel__entry-main">
                    <span class="audit-log-panel__entry-title">{{ operationLabel(change) }}</span>
                  </div>

                  <div class="audit-log-panel__entry-meta">
                    <span>{{ actor(change) }}</span>
                    <time [attr.datetime]="change.changedAt">{{ change.changedAt | zagDateTime }}</time>
                  </div>

                  <div class="audit-log-panel__entry-source">{{ change.schemaName }}.{{ change.tableName }}</div>
                </div>

                <span
                  zagIcon="expand-more"
                  class="audit-log-panel__entry-chevron"
                  [class.audit-log-panel__entry-chevron--expanded]="isExpanded(change.id)"
                ></span>
              </button>

              @if (isExpanded(change.id) && diff.length > 0) {
                <div class="audit-log-panel__diff" [attr.id]="'audit-log-change-' + change.id">
                  <table class="audit-log-panel__diff-table" [attr.aria-label]="'audit.panel.diff.label' | translate">
                    <thead>
                      <tr>
                        <th class="audit-log-panel__diff-th">{{ 'audit.panel.diff.field' | translate }}</th>
                        @if (change.operation !== 'INSERT') {
                          <th class="audit-log-panel__diff-th">{{ 'audit.panel.diff.from' | translate }}</th>
                        }
                        @if (change.operation !== 'DELETE') {
                          <th class="audit-log-panel__diff-th">{{ 'audit.panel.diff.to' | translate }}</th>
                        }
                      </tr>
                    </thead>
                    <tbody>
                      @for (entry of diff; track entry.field) {
                        <tr class="audit-log-panel__diff-row">
                          <td class="audit-log-panel__diff-field">{{ entry.field }}</td>
                          @if (change.operation !== 'INSERT') {
                            <td class="audit-log-panel__diff-value audit-log-panel__diff-value--old">
                              {{ entry.oldValue ?? '—' }}
                            </td>
                          }
                          @if (change.operation !== 'DELETE') {
                            <td class="audit-log-panel__diff-value audit-log-panel__diff-value--new">
                              {{ entry.newValue ?? '—' }}
                            </td>
                          }
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              }
            </article>
          }
        }
      }
    </div>
  </div>
</zag-drawer>
